import { gql } from "@apollo/client"

const GET_WAITING_LIST = gql`
  query($orderBy: [QueryReportWaitingListOrderByOrderByClause!], $first: Int!, $page: Int!, $input: ReportWaitingListInput!) { 
    reportWaitingList(orderBy: $orderBy, page: $page, first: $first, input: $input) {
      data {
        id
        lesson_id
        group_id
        guardian_id
        student_id
        session
        group
        student
        lesson
        guardian
        available_slots
        has_booked
        comment
        created_at
        booking_slot_created_at
      }

      paginatorInfo {
        total
        currentPage
        hasMorePages
        lastPage
        perPage
      }
    }
  }
`

export default GET_WAITING_LIST
